import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">实时更新的综艺热度排行，发现大家都在看的热门内容</p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading text-lg font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 truncate">{item.title}</h3>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                ) : (
                  <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                )}
                <span className="text-sm font-medium text-foreground-600 whitespace-nowrap">{item.heat}</span>
              </div>

              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 cursor-pointer hover:bg-primary-200 transition-colors">
                <i className="ri-play-fill text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}